import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '@shared/services/date-format.service';


@Pipe({
    name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
    readonly #formatService: DateFormatService = inject(DateFormatService);

    public transform(value: Date | string, args?: 'date' | 'full' | 'my' ): string {
        return this.#formatService.format(value, args);
    }
}
